import { z } from "zod";

/** eQuality — non-conformance response, modeled on the legacy ETQ-backed
 * workflow via an adapter (sandbox data in Wave 1). */
export const ncrRespondSchema = z.object({
  ncrId: z.number().int(),
  dispositionType: z.string().min(1),
  responseText: z.string().min(1),
});
export type NcrRespondInput = z.infer<typeof ncrRespondSchema>;

export const disputeSchema = z.object({
  ncrId: z.number().int(),
  reasonForDispute: z.string().min(1),
});
